import React from 'react';
import PropTypes from 'prop-types';
import FormSettingsField from './FormSettingsField';
import Input from '@mdigital/components/dist/components/Input';
import RadioButtons from '@mdigital/components/dist/components/RadioButtons';
import { StyledFormNameContainer, StyledFormID, StyledFormIdContainer } from './StyledFormBasicSettings';
import { getSingleText } from '../../../common/utils';
import { Links } from '../TriggeringModal/enumns/links.enumn';
import { checkProvision } from '../../../redux/store/store-helper';

const CustomViewLink = () => (
  <p>{getSingleText('app.pages.forms.formBasicSettings.customViewHelpText')}&nbsp;
    <a href={Links.CUSTOM_VIEW} target="_blank">{getSingleText('app.pages.forms.formBasicSettings.documentationLinkText')}</a>
  </p>
);

const FormIdentifiersWithoutDraft = ({ formSettings }) => {
  return (<StyledFormIdContainer>
    <StyledFormID>
      {getSingleText('app.pages.forms.formBasicSettings.formId')}{formSettings.id}
    </StyledFormID>
    <StyledFormID>
      {getSingleText('app.pages.forms.formBasicSettings.uuid')} {formSettings.uuid}
    </StyledFormID>
  </StyledFormIdContainer>);
};
const FormIdDisplay = ({ formSettings, isPublished }) => {
  const isSurveyDraftEnabled = checkProvision(DigProvisions.ENABLE_SURVEY_DRAFTS);
  const isDraft = !isPublished;
  const hasFormId = !!formSettings.formId;

  if (!isSurveyDraftEnabled) {
    return <FormIdentifiersWithoutDraft formSettings={formSettings} />;
  }

  if (isDraft && hasFormId) {
    return (
      <StyledFormIdContainer>
        <StyledFormID>
          {getSingleText('app.pages.forms.formBasicSettings.draftId')} {formSettings.id}
        </StyledFormID>
        <StyledFormID>
          {getSingleText('app.pages.forms.formBasicSettings.formId')} {formSettings.formId}
        </StyledFormID>
        <StyledFormID>
          {getSingleText('app.pages.forms.formBasicSettings.uuid')} {formSettings.uuid}
        </StyledFormID>
      </StyledFormIdContainer>
    );
  } else {
    return <FormIdentifiersWithoutDraft formSettings={formSettings} />;
  }
};


const BasicSettings = ({ values , mutators, isPublished }) => {
  const filteredRadioButtonsOptions = checkProvision(DigProvisions.ENABLE_CUSTOM_SURVEY_VIEWS) ?
    radioButtonsOptions :
    radioButtonsOptions.filter((option) =>  option.digValue !== 'custom');
  return (
    <React.Fragment>
		  <FormSettingsField
			  name="formSettings.name"
			  title="Form Name"
			  required
			  errorMessage="Form Name is Required"
			  isDisabled={isPublished}
			  render={({ input }) => (
				  <StyledFormNameContainer>
					  <Input digValue={input.value} digOnChange={input.onChange}/>
            <FormIdDisplay formSettings={values.formSettings} isPublished={isPublished} />
				  </StyledFormNameContainer>
			  )}/>
		  <FormSettingsField
			  name="formSettings.settings.formMobileSettingsContract.formViewType"
			  title="Form View"
			  errorMessage="Form View is Required"
			  isDisabled={isPublished}
			  render={({ input }) => (
				  <RadioButtons digCurrentValue={values.formSettings.settings.formMobileSettingsContract.formViewType}
											  digValue={input.value} digRadioButtons={filteredRadioButtonsOptions}
											  digOnChange={(e) => {
												  mutators.setFormViewType(e.target.value);
											  }}
											  layoutOrientation="horizontal"/>
			  )}/>
		  {values.formSettings.settings.formMobileSettingsContract.formViewType === 'custom' && <CustomViewLink/>}
    </React.Fragment>
  );
};

const radioButtonsOptions = [
  {
    digLabel: 'Partial Screen',
    digValue: 'modal',
  },
  {
    digLabel: 'Full Screen',
    digValue: 'full',
  },
  {
    digLabel: 'Custom View',
    digValue: 'custom',
  }
];

export default BasicSettings;

BasicSettings.propTypes = {
  values: PropTypes.object,
  mutators: PropTypes.object,
  isPublished: PropTypes.bool,
};

BasicSettings.defaultProps = {
  values: {},
  mutators: {},
  isPublished: false,
};

FormIdDisplay.propTypes = {
  formSettings: PropTypes.object,
  isPublished: PropTypes.bool,
};

FormIdDisplay.defaultProps = {
  formSettings: {},
  isPublished: false,
};
